import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';

const FacturasConciliarHeader = ({
    facturasFiltradas,
    facturasSeleccionadas,
    setFacturasSeleccionadas,
    totalFacturasSeleccionadas,
    onConciliar,
    cargandoConciliacion
}) => {
    return (
        <Row className="align-items-center">
            <Col xs={12} xl="auto" className="text-end d-flex flex-wrap align-items-center justify-content-end gap-3 mt-2 mt-xl-0">
                <div className="d-flex align-items-center gap-3">
                    <small className="text-primary fw-bold">
                        {facturasFiltradas.length} facturas
                    </small>
                </div>
                <div 
                    className="d-flex align-items-center gap-3 transition-base"
                    style={{ 
                        visibility: facturasSeleccionadas.length > 0 ? 'visible' : 'hidden',
                        opacity: facturasSeleccionadas.length > 0 ? 1 : 0
                    }}
                >
                    <small className="text-primary fw-bold">
                        | {facturasSeleccionadas.length} seleccionada{facturasSeleccionadas.length !== 1 ? 's' : ''} | Total: ${(totalFacturasSeleccionadas || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN |
                    </small>
                    <Button
                        variant="link"
                        className="p-0 text-danger text-decoration-none fs--1"
                        onClick={() => setFacturasSeleccionadas([])}
                        disabled={facturasSeleccionadas.length === 0}
                    >
                        <i className="fas fa-times me-1"></i>
                        Deseleccionar todas
                    </Button>
                    <Button
                        variant="success"
                        size="sm"
                        className="ms-2 fw-bold"
                        onClick={onConciliar}
                        disabled={cargandoConciliacion || facturasSeleccionadas.length === 0}
                    >
                        {cargandoConciliacion ? (
                            <><span className="spinner-border spinner-border-sm me-2" />Conciliando...</>
                        ) : (
                            <><i className="fas fa-check-circle me-2"></i>Conciliar</>
                        )}
                    </Button>
                </div>
            </Col>
        </Row>
    );
};

FacturasConciliarHeader.propTypes = {
    facturasFiltradas: PropTypes.array,
    facturasSeleccionadas: PropTypes.array,
    setFacturasSeleccionadas: PropTypes.func,
    totalFacturasSeleccionadas: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onConciliar: PropTypes.func,
    cargandoConciliacion: PropTypes.bool
};

export default FacturasConciliarHeader;
